import React from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

import { useLocation } from "react-router-dom";
import DownArrow from "../../../assets/icons/down-arrow";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import { toggleModal } from "../../../redux/slices/duonutSettings";

import NavItem from "./navItem";

export default function NavItems() {
  const location = useLocation();
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const { title } = useSelector((state) => state.duonutSettings.settings);

  const handleClick = () => {
    dispatch(toggleModal());
  };

  let trimmedTitle = "";
  if (title === "") {
    trimmedTitle = title;
  } else {
    title.length > 10 ? (trimmedTitle = `${title.substr(0, 10)}...`) : (trimmedTitle = title);
  }

  return (
    <ul className="navbar-container__items" style={{ display: location.pathname.substring(0,7) === "/design" ? "block" : "" }}>
      {/* <NavItem text='Home' linkTo='./home' /> */}

      {/* nav items for home page */}

      {location.pathname.substring(0,7) !== `/design`   ? (
        <>
          <NavItem text="Create" linkTo="/design" />
          <NavItem text="All Duonuts" linkTo="/allduonuts" />
          <NavItem text="What are Duonuts ?" linkTo="/" />
          <NavItem text="About Us" linkTo="/" />
          <NavItem text="Contact Us" linkTo="/" />
        </>
      ) : (
        <button className="settings_title_button" onClick={handleClick}>
          <span>{title ? trimmedTitle : width > 1100 ? "Untitled Duonut" : "Untitled Duo..."}</span>
          {/* <img src="/assets/icons/settings.svg" /> */}
          {/* <img src="../assets/icons/down.svg" className="settings_title_icon" /> */}
          <div className="down-arrow">
            <DownArrow fill={width < 1100 ? "white" : "black"} />
          </div>
        </button>
      )}
    </ul>
  );
}
